import { controls,grouped } from "../controls";
const probable_matches = {
label: "Probable Matches",
pageLabel: "Probable Matches",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:true} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Saral Id",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "saral_id",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Full Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "full_name",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Fathers Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "fathers_name",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Mothers Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "mothers_name",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Data Of Birth",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "data_of_birth",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "School Name",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "school_name",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Saral Class",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "saral_class",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Village",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "village",width:"col-sm-4",maxlength:100}),
...controls.displayText({ tab: "general", label: "Taluka",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "taluka",width:"col-sm-4",maxlength:100}),
]
,history:{
perPage: 10,
reportHeader: "Probable Matches",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Saral Id",accessor: "saral_id",},
{Header: "Full Name",accessor: "full_name",},
{Header: "Fathers Name",accessor: "fathers_name",},
{Header: "Mothers Name",accessor: "mothers_name",},
{Header: "Data Of Birth",accessor: "data_of_birth",},
{Header: "School Name",accessor: "school_name",},
{Header: "Saral Class",accessor: "saral_class",},
{Header: "Village",accessor: "village",},
{Header: "Taluka",accessor: "taluka",},
]}};
export default probable_matches;